import lignesNormalesGetter from '@/services/devisCommandes/lignesNormalesGetter';

export default function validationRegroupementPersonnaliseCommande(
  lignesCommandesARegrouper, devisCommande, messages,
) {
  let retour = true;
  lignesCommandesARegrouper.forEach(ligne => {
    if (!ligne.referenceEcheancier) {
      return;
    }
    const echeancier = devisCommande.echeanciers.find(ech => {
      return ech.referenceEcheancier === ligne.referenceEcheancier;
    });
    if (echeancier.quantitePeriodicite !== 0) {
      messages.push({ message: 'ligneRegroupementPersonnalisee.errors.commande.echeancierManuel' });
      retour = false;
    }
    if (echeancier.echeancierLignes.find(ligneEch => {
      return !!ligneEch.factureId;
    })) {
      messages.push({ message: 'ligneRegroupementPersonnalisee.errors.commande.bill' });
      retour = false;
    }

    const allLinesNormal = lignesNormalesGetter(devisCommande);

    if (allLinesNormal.filter(ligneCommande => {
      return ligneCommande.referenceEcheancier === ligne.referenceEcheancier;
    }).length > 1) {
      messages.push({ message: 'ligneRegroupementPersonnalisee.errors.commande.echeancierRegroupe' });
      retour = false;
    }
  });
  return retour;
}
